import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { titleStyle } from './numberingSeriesCell.css';

type Props = {
  name: string;
};

export const NumberingSeriesNameCell = ({ name }: Props) => {
  return <div className={clsx(desktopTruncateStyle, titleStyle)}>{name}</div>;
};
